<section class="section-div">
  <div class="content-details">
    <div class="container-fluid">
      <div class="title-details">
        <div class="d-flex">
          <h4><ion-icon name="calendar-outline"></ion-icon> CoE List</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div>
            <div class="ml-auto">
              <mat-form-field appearance="standard" class="material-full-width">
                <mat-label
                  >Search By Host Institution Name or Application Number
                </mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input
                  matInput
                  (keyup)="applySearch($event)"
                  placeholder="Search By Host Institution Name or Application Number"
                  #input
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="offset-1 col-lg-4 col-md-4">
          <form action="" [formGroup]="formValue">
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>Status<span class="text-danger">*</span></mat-label>
                <mat-select
                  (selectionChange)="onSelect($event.value)"
                  formControlName="type"
                >
                  <mat-option value="0">Pending</mat-option>
                  <mat-option value="1">Submitted</mat-option>
                  <mat-option value="3">Under Clarification</mat-option>
                  <mat-option value="6">Clarification Submited</mat-option>
                  <mat-option value="7"
                    >Process Verificiation Pending</mat-option
                  >
                  <mat-option value="2">Under Process Verificiation</mat-option>
                  <mat-option value="4">Approved</mat-option>
                  <mat-option value="5">Rejected</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </form>
        </div>

        <div class="mt-3 col-lg-1 col-md-1" *ngIf="noData == false">
          <div class="download-div">
            <button mat-raised-button color="accent" (click)="openModal()">
              Export <i class="far fa-file-excel"></i>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="noData == false">
        <div class="example-container mat-elevation-z8">
          <mat-table
            #table
            [dataSource]="dataSource"
            [class.isMobile]="isMobile"
          >
            <ng-container matColumnDef="index">
              <mat-header-cell *matHeaderCellDef class="max-width">
                No.
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element; let i = index"
                class="max-width"
              >
                <span class="mobile-label">No :</span>
                {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="incubatorName">
              <mat-header-cell *matHeaderCellDef
                >Host Institution Name
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">Host Institution Name :</span>
                <a
                  class="c-blue"
                  (click)="incubaName(element.userid, element.name)"
                  matTooltip="View Application"
                  matTooltipPosition="above"
                >
                  {{ element.name }}
                </a>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="applicationNumber">
              <mat-header-cell *matHeaderCellDef class="max-width2"
                >Application Number</mat-header-cell
              >
              <mat-cell *matCellDef="let element" class="max-width2">
                <span class="mobile-label">Application Number :</span>
                <span *ngIf="element.applicationNumber">
                  {{ element.applicationNumber }}
                </span>
                <span class="reason-center2" *ngIf="!element.applicationNumber"
                  >-</span
                >
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="profileRegistered">
              <mat-header-cell *matHeaderCellDef class="max-width3"
                >Application Status
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="max-width3">
                <span class="mobile-label">Application Status :</span>
                <span *ngIf="element.applicationStatus == 0">Pending</span>
                <span *ngIf="element.applicationStatus == 1">Submitted</span>
                <span *ngIf="element.applicationStatus == 2"
                  >Under Process Verficiation</span
                >
                <span *ngIf="element.applicationStatus == 3"
                  >Under Clarification</span
                >
                <span *ngIf="element.applicationStatus == 4">Approved</span>
                <span *ngIf="element.applicationStatus == 5">Rejected</span>
                <span *ngIf="element.applicationStatus == 6"
                  >Clarification Submitted</span
                >
                <span *ngIf="element.applicationStatus == 7">
                  Process Verificiation Pending</span
                >
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="time">
              <mat-header-cell *matHeaderCellDef class="max-width2">
                Submission Date</mat-header-cell
              >
              <mat-cell *matCellDef="let element" class="max-width2">
                <span class="mobile-label">Submission Date :</span>
                <span *ngIf="element.formattedTime">
                  {{ element.formattedTime }}
                </span>
                <span class="reason-center2" *ngIf="!element.formattedTime"
                  >-</span
                >
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="reason">
              <mat-header-cell *matHeaderCellDef class="max-width2">
                Remarks</mat-header-cell
              >
              <mat-cell *matCellDef="let element" class="max-width2">
                <span class="mobile-label">Remarks :</span>
                <span class="eye-icon reason-center">
                  <img
                    src="/assets/images/eye.png"
                    alt=""
                    (click)="
                      viewDescrptionBtn(
                        element.reason,
                        'Remarks',
                        element.applicationId
                      )
                    "
                  />
                </span>
              </mat-cell>
            </ng-container>
            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>

        <mat-paginator
          #paginator
          class="mat-elevation-z8"
          [length]="pageTotalCount"
          [pageSize]="pageSize"
          [pageSizeOptions]="[25, 50, 75, 100]"
          showFirstLastButtons
          (page)="getServerData($event)"
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </div>
      <div class="text-center no-data-div" *ngIf="noData == true">
        <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
        <h6>No Records Found</h6>
      </div>
    </div>
  </div>
</section>
